
/* ══ OCULUS — product data ══ */
const PR = [
 {slug:'sleeveless-hoodie', n:'01', name:'Sleeveless Hoodie', gar:'Sleeveless Hooded Sweatshirt', col:'Void',
  gsm:370, comp:'54.7% polyester, 39.8% cotton, 5.5% elastane', fit:'Loose, boxy', sizes:['S','M','L','XL','2XL'],
  code:'UT0174', aff:'Made in the image of G⊙D', prt:'DTG', px:'$145',
  desc:'Sleeveless hooded sweatshirt in black heavyweight fleece. Loose boxy fit with a drawcord hood, metal eyelets to both sides and a studded pouch pocket. Sun-fade washed. Marble graphic to the rear, edition plate below.',
  hand:'The only piece cut open at the arm and heavy at the shoulder.',
  f:['01-front','02-back','03-hood-up-turn','04-profile','05-seated','06-light-shaft']},
 {slug:'sweatshirt', n:'02', name:'Sweatshirt', gar:'Mineral Wash Boxy Crewneck', col:'Washed Black',
  gsm:380, comp:'100% cotton', fit:'Boxy, cropped', sizes:['S','M','L','XL','2XL'],
  code:'UT0088', aff:'Believe', prt:'DTG', px:'$145',
  desc:'Crewneck sweatshirt in washed black heavyweight cotton. Boxy cropped fit with dropped raglan shoulders, a ribbed collar, ribbed cuff and a wide ribbed hem. Mineral washed to a clouded surface. Winged marble figure and creed to the rear, wordmark to the chest.',
  hand:'Dense and dry, clouded by the wash.',
  f:['01-front','02-rear-turn','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'quarter-zip', n:'03', name:'Quarter-Zip', gar:'Mineral Wash Boxy Quarter-Zip', col:'Washed Black',
  gsm:350, comp:'100% cotton', fit:'Boxy, slightly cropped', sizes:['S','M','L','XL','2XL'],
  code:'UT0183', aff:'For the chosen ones', prt:'DTG', px:'$155',
  desc:'Quarter-zip sweatshirt in washed black heavyweight cotton. Boxy fit with a flat pointed collar, short metal zip, dropped shoulder seams, ribbed cuff and hem. Mineral washed. Cherubim to the rear, wordmark to the chest.',
  hand:'Collared, and it holds its shape.',
  f:['01-front','02-rear-turn','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'hoodie', n:'04', name:'Hoodie', gar:'Snow Wash Boxy Fleece Hoodie', col:'Washed Black',
  gsm:400, comp:'100% cotton', fit:'Loose, boxy', sizes:['S','M','L','XL','2XL'],
  code:'RW0024', aff:'Made in the image of G⊙D', prt:'DTG', px:'$165',
  desc:'Pullover hoodie in washed black heavyweight cotton fleece. Loose boxy fit with a drawcord hood, dropped shoulder seams, kangaroo pouch pocket, ribbed cuff and a hem cut open and left to fray. Mineral washed. Winged marble figure and creed to the rear, wordmark and edition line to the chest.',
  hand:'Four hundred grams of pure cotton, and it hangs like it.',
  f:['01-front','02-rear-turn','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'boxy-tee', n:'05', name:'Boxy Tee', gar:'Snow Wash Raw-Hem Boxy T-Shirt', col:'Washed Black',
  gsm:340, comp:'100% cotton', fit:'Oversized, drop shoulder', sizes:['S','M','L','XL'],
  code:'RT0058', aff:'Born to be great', prt:'DTG', px:'$85',
  desc:'Short sleeve jersey t-shirt in washed black heavyweight cotton. Cut wide and short — sitting at the waist, not below the hip — with dropped shoulder seams and a ribbed crewneck. Snow washed, hem cut open and left to fray. Marble graphic to the rear, wordmark to the chest.',
  hand:'Compact and dry to the hand, and it softens with every wash.',
  f:['01-front','02-rear-turn','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'hooded-tank', n:'06', name:'Hooded Tank', gar:'Snow Washed Boxy Hooded Tank', col:'Washed Black',
  gsm:270, comp:'87% cotton, 13% polyester', fit:'Loose, boxy', sizes:['S','M','L','XL','2XL'],
  code:'RB0006', aff:'Born to be great', prt:'DTG', px:'$95',
  desc:'Sleeveless hooded tank in washed black cotton. Loose boxy fit, raw armholes, frayed hem. Washed and ripped. Marble bust to the rear, wordmark to the chest.',
  hand:'Open at the arm, heavy at the shoulder.',
  f:['01-front','02-hood-up-rear','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'tank', n:'07', name:'Tank', gar:'Snow Washed Raw-Hem Tank', col:'Washed Black',
  gsm:275, comp:'100% cotton', fit:'Loose', sizes:['S','M','L','XL','2XL'],
  code:'RB0013', aff:'For the chosen ones', prt:'DTG', px:'$70',
  desc:'Sleeveless tank in washed black heavyweight cotton. Loose fit, raw armholes, ripped hem left unfinished. Snow washed. Seal to the chest, creed to the rear.',
  hand:'The quietest piece in the collection.',
  f:['01-front','02-rear-turn','03-back','04-light-shaft','05-seated','06-profile']},
 {slug:'short', n:'08', name:'Short', gar:'Vintage Wash Distressed Wide Leg Short', col:'Washed Black',
  gsm:350, comp:'100% cotton', fit:'Loose, wide leg', sizes:['XS','S','M','L','XL'],
  code:'UB0042', aff:'Born to be great', prt:'DTG', px:'$120',
  desc:'Wide-leg short in washed black heavyweight cotton. Knee length, elasticated drawcord waist, side and rear pockets. Vintage washed, distressed, hem left raw. Creed and edition to the rear.',
  hand:'Cut wide, falls heavy.',
  f:['01-front','02-back','03-seated']},
];
const pimg=(p,fr)=>SOGA['oculus-'+p.slug+'-'+fr+'.webp']||('products/'+p.slug+'/oculus-'+p.slug+'-'+fr+'.webp');

/* ══ 03 · build the collection grid ══ */
(function(){
  const g=document.getElementById('grid6');
  g.innerHTML = PR.map((p,i)=>`
    <a class="pc rev" data-i="${i}" href="#" aria-label="${p.name}">
      <img class="pri" src="${pimg(p,p.f[0])}" alt="${p.name} front" loading="lazy" decoding="async">
      <img class="alt" src="${pimg(p,p.f[2]||p.f[1])}" alt="${p.name} back" loading="lazy" decoding="async">
      <span class="n">${p.n}</span>
      <span class="cap">
        <span><span class="t">${p.name}</span><span class="s">${p.col}</span></span>
        <span class="px">${p.px}</span>
      </span>
    </a>`).join('');
})();

/* == THE LIST -- capture helper ==
   One place that knows how a signup is recorded, shared by the hero field, the
   House card and the footer. Addresses go to Shopify as customers via the
   native {% form 'customer' %} route: no API key in the browser, and Shopify's
   own captcha rides along, which a hand-built fetch cannot satisfy (it answers
   400 "Missing CAPTCHA token" -- that is why this was left unwired).
   The form posts natively and Shopify returns to ?joined=<which>. Everything
   we want to know but will not ask for -- campaign, referrer, which field they
   used -- is written to contact[tags] on the way out. */
window.SOGLIST=(function(){
  var KEY='sog_list';
  function ls(k,d){try{return JSON.parse(localStorage.getItem(k)||d)}catch(e){return JSON.parse(d)}}
  function save(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
  function valid(v){return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)}
  function member(){return ls(KEY,'[]').length>0}
  function remember(v){var l=ls(KEY,'[]'); if(l.indexOf(v)<0){l.push(v);save(KEY,l)} }
  /* the campaign that produced the signup, kept for the life of the visit --
     a click from Instagram lands on the hero and joins from the popup twelve
     seconds later, by which time the utm is long gone from the URL */
  function attrib(){
    var t=[];
    try{
      var q=new URLSearchParams(location.search), keep=null;
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){
        var v=q.get(k); if(v){t.push(k.replace('utm_','')+':'+v.slice(0,40)); keep=1}
      });
      if(keep) sessionStorage.setItem('sog_utm',t.join(','));
      else { var st=sessionStorage.getItem('sog_utm'); if(st) t=st.split(','); }
      if(!t.length && document.referrer){
        var h=new URL(document.referrer).hostname.replace(/^www\./,'');
        if(h && h!==location.hostname) t.push('ref:'+h.slice(0,40));
      }
    }catch(e){}
    return t;
  }
  /* consent:v1 == the wording shown at the field on 6 Sep 2026: one email per
     drop, unsubscribe anytime, agreement to be emailed about the drop, privacy
     policy linked. Change the wording, change the version -- Shopify already
     stamps the moment, this stamps what they were shown. */
  function tags(which,extra){
    var t=['list','consent:v1','drop:oculus-01','via:'+which].concat(extra||[]).concat(attrib());
    return t.join(',').replace(/[^a-zA-Z0-9:,._-]/g,'').slice(0,240);
  }
  /* a bot that does not run scripts fills the decoy and never reaches Shopify */
  function trapped(form){
    var hp=form.querySelector('.hp'); return !!(hp && hp.value);
  }
  /* which form came back from Shopify, if any */
  function returned(){
    try{ return new URLSearchParams(location.search).get('joined'); }catch(e){ return null; }
  }
  function clean(){
    try{
      var u=new URL(location.href); u.searchParams.delete('joined');
      history.replaceState(null,'',u.pathname+(u.search||'')+u.hash);
    }catch(e){}
  }
  return {valid:valid,member:member,remember:remember,tags:tags,
          trapped:trapped,returned:returned,clean:clean};
})();

/* == 01b . the list -- drop capture ==
   NOT WIRED ON PURPOSE. Same posture as checkout: the form is honest about the
   fact that nothing is transmitted yet. Point ENDPOINT at Shopify customer
   create / Klaviyo on release and swap the stub for a fetch(). Until then
   entries are held in localStorage['sog_list'] so preview signups are not lost. */
(function(){
  var L=window.SOGLIST;
  var box=document.getElementById('list');
  if(!box) return;
  var form=document.getElementById('listForm'),
      mail=document.getElementById('listEmail'),
      msg =document.getElementById('listMsg'),
      tags=document.getElementById('listTags');
  function say(t,err){msg.textContent=t;msg.classList.add('on');
    msg.classList.toggle('err',!!err)}
  function done(){box.classList.add('done');form.style.display='none';
    say('Received \u2014 you are on the list for Drop 02',false)}

  if(L.returned()==='list'){ done(); L.clean(); }

  form.addEventListener('submit',function(e){
    var v=mail.value.trim();
    if(!L.valid(v)){e.preventDefault();say('Enter a valid email address',true);mail.focus();return}
    if(L.trapped(form)){e.preventDefault();return}
    if(tags) tags.value=L.tags('hero');
    L.remember(v);
    say('One moment\u2026',false);
  });
  mail.addEventListener('input',function(){msg.classList.remove('on','err')});
})();

/* == 01c . JOIN THE HOUSE ==
   Trigger is evidence-led, not taste-led. Two independent datasets of ~1bn
   popup displays each (Omnisend 2025, Wisepops 2026) agree on two things:
     - the converting window is 6-15s; it falls off a cliff after ~16s
     - exit-intent is the WEAKEST trigger (1.8% / 3.94%), not the strongest,
       because it catches people who have already decided to leave
   Wisepops' best single signal is "2 pages viewed" (9.84%). This is a one-page
   store, so the Collection entering view is the honest local equivalent.
   Hence: 12s OR Collection-in-view, whichever comes first.

   Frequency, the way every house does it — joining and declining are not the
   same answer, so they are not capped the same way:
     joined      -> never asked again, ever
     first no    -> asked once more on their next visit
     second no   -> left alone for a week
   State lives in localStorage['sog_house'] = {n: refusals, t: last refusal}.

   NOT WIRED. Point ENDPOINT at Shopify customer create / Klaviyo on release.
   Shares localStorage['sog_list'] with the hero field so a member is never
   asked twice. */
(function(){
  var L=window.SOGLIST;
  var DELAY    = 12000;
  var KEY='sog_list', LOG='sog_house';
  var GRACE = 7*24*60*60*1000;               /* after the second no, a week */
  var hs=document.getElementById('hs');
  if(!hs) return;
  var form=document.getElementById('hsForm'),
      mail=document.getElementById('hsEmail'),
      msg =document.getElementById('hsMsg'),
      fired=false, hatched=false, lastFocus=null,
      CTX=[], WHICH='house';

  function ls(k,d){try{return JSON.parse(localStorage.getItem(k)||d)}catch(e){return JSON.parse(d)}}
  function save(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
  function member(){return ls(KEY,'[]').length>0}
  function log(){var l=ls(LOG,'{}')||{}; return {n:l.n||0,t:l.t||0}}
  function welcome(){                        /* may we ask? */
    if(member()) return false;               /* they joined — done forever */
    var l=log();
    if(l.n<2) return true;                   /* first no: ask again next visit */
    return (Date.now()-l.t) > GRACE;         /* second no: wait it out */
  }

  /* never interrupt another surface */
  function busy(){
    return document.querySelector('.veil.open,.pdp.open,.bagp.open')!==null ||
           document.body.classList.contains('locked');
  }
  function open(){
    if(fired||!welcome()||busy()) return;
    fired=true;
    lastFocus=document.activeElement;
    hs.classList.add('open'); hs.setAttribute('aria-hidden','false');
    document.body.classList.add('locked');
    setTimeout(function(){try{mail.focus({preventScroll:true})}catch(e){}},760);
  }
  /* the refusal is recorded when they close it, not when it opens — someone who
     navigates away mid-look has not said no, and is asked again next time */
  function close(){
    hs.classList.remove('open'); hs.setAttribute('aria-hidden','true');
    if(!document.querySelector('.pdp.open,.veil.open,.bagp.open'))
      document.body.classList.remove('locked');
    if(!hatched && !member()){var l=log(); save(LOG,{n:l.n+1,t:Date.now()})}
    if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true})}catch(e){}
  }

  /* review + deep-link hatch: /#join always opens it, ignoring "already seen".
     Also lets the House be linked to directly from email or the veil footer. */
  function hatch(){
    if(location.hash!=='#join') return false;
    fired=false; hatched=true; hs.classList.remove('done');
    lastFocus=document.activeElement;
    hs.classList.add('open'); hs.setAttribute('aria-hidden','false');
    document.body.classList.add('locked');
    setTimeout(function(){try{mail.focus({preventScroll:true})}catch(e){}},760);
    return true;
  }
  window.addEventListener('hashchange',hatch);

  /* Opened deliberately from a product page. The visitor asked, so this path
     ignores both the "already seen" gate and busy() -- and it carries the
     piece and the size they were looking at into the signup's tags. */
  window.SOGHOUSE={ask:function(which,extra){
    WHICH=which||'house'; CTX=extra||[];
    fired=false; hatched=true; hs.classList.remove('done');
    lastFocus=document.activeElement;
    hs.classList.add('open'); hs.setAttribute('aria-hidden','false');
    document.body.classList.add('locked');
    setTimeout(function(){try{mail.focus({preventScroll:true})}catch(e){}},520);
  }};

  /* back from Shopify with the address saved: show the code, do not re-ask */
  if(L.returned()==='house'){
    L.clean();
    fired=true; hatched=true;
    hs.classList.add('open','done'); hs.setAttribute('aria-hidden','false');
    document.body.classList.add('locked');
    var won=hs.querySelector('.won');
    if(won){won.setAttribute('tabindex','-1');
      setTimeout(function(){try{won.focus({preventScroll:true})}catch(e){}},400)}
    hs.addEventListener('click',function(e){
      if(e.target.closest('[data-hsclose]')) close();
    });
    var cpx=document.getElementById('hsCopy');
    if(cpx) cpx.addEventListener('click',function(){
      var code=document.getElementById('hsCode').textContent.trim();
      if(navigator.clipboard) navigator.clipboard.writeText(code).then(function(){
        cpx.textContent='Copied';setTimeout(function(){cpx.textContent='Copy code'},2200)},function(){});
    });
    return;
  }
  hs.addEventListener('click',function(e){
    if(e.target.closest('[data-hsclose]')) close();
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape'||!hs.classList.contains('open')) return;
    close();
  });
  /* keep tab inside the card while it is open */
  hs.addEventListener('keydown',function(e){
    if(e.key!=='Tab') return;
    var f=hs.querySelectorAll('button,input,[href]');
    if(!f.length) return;
    var a=f[0], z=f[f.length-1];
    if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus()}
    else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}
  });

  var tagf=document.getElementById('hsTags');
  form.addEventListener('submit',function(e){
    var v=mail.value.trim();
    if(!L.valid(v)){e.preventDefault();msg.textContent='Enter a valid email address';
      msg.classList.add('on');mail.focus();return}
    if(L.trapped(form)){e.preventDefault();return}
    var favEl=document.getElementById('hsFav'), telEl=document.getElementById('hsPhone');
      var EX=(CTX||[]).slice();
      if(favEl){ if(!favEl.value){ e.preventDefault(); msg.textContent='Choose the piece you want most';
        msg.classList.add('on'); favEl.focus(); return; } EX.push('fav:'+favEl.value); }
      if(telEl && telEl.value.trim()) EX.push('tel:'+telEl.value.trim().replace(/[^0-9+]/g,'').slice(0,22));
      if(tagf) tagf.value=L.tags(WHICH,EX);
    L.remember(v);
    msg.textContent='One moment\u2026'; msg.classList.add('on');
  });
  mail.addEventListener('input',function(){msg.classList.remove('on')});

  /* everything above binds unconditionally; only the automatic open is
     gated, so a card reached by #join behaves exactly like one that opened
     itself -- it closes, it submits, it carries its tags. */
  function arm(){
  if(hatch()) return;

  if(!welcome()) return;                     /* nothing armed at all */

  var timer=setTimeout(open,DELAY);
  var coll=document.getElementById('collection');
  if(coll&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      if(en[0].isIntersecting){io.disconnect();clearTimeout(timer);open()}
    },{threshold:.25});
    io.observe(coll);
  }
  }

  var cp=document.getElementById('hsCopy');
  cp.addEventListener('click',function(){
    var code=document.getElementById('hsCode').textContent.trim();
    function done(){cp.textContent='Copied';setTimeout(function(){cp.textContent='Copy code'},2200)}
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(code).then(done,function(){})
    }else{
      var t=document.createElement('textarea');t.value=code;document.body.appendChild(t);
      t.select();try{document.execCommand('copy');done()}catch(e){}document.body.removeChild(t);
    }
  });

  arm();
})();

/* ══ 05 · the room ══ */
(function(){
  const R=[['the-wings','The Wings','Fig. I','sleeveless-hoodie'],
           ['assembly-front','Before the Stone','Fig. II','sleeveless-hoodie'],
           ['vest-bust','The Bust','Fig. III','hooded-tank'],
           ['among-them','Among Them','Fig. IV','quarter-zip'],
           ['unfinished','Unfinished','Fig. V','hoodie'],
           ['the-sitting','The Sitting','Fig. VI','hooded-tank'],
           ['ghost-congregation','The Congregation','Fig. VII','hoodie'],
           ['the-fragment','The Fragment','Fig. VIII','short'],
           ['ghost-seated','What Was Left','Fig. IX','sleeveless-hoodie'],
           ['plinth-group','The Vault','Fig. X','hoodie'],
           ['the-procession','The Procession','Fig. XI','hoodie'],
           ['the-niche','The Niche','Fig. XII','quarter-zip'],
           ['the-vigil','The Vigil','Fig. XIII','hoodie'],
           ['the-dressing','The Dressing','Fig. XIV','sweatshirt'],
           ['the-sentinel','The Sentinel','Fig. XV','quarter-zip'],
           ['the-shroud','The Shroud','Fig. XVI','sweatshirt'],
           ['plinth-tee','The Artefact','Fig. XVII','boxy-tee'],
           ['the-offering','The Offering','Fig. XVIII','sweatshirt'],
           ['the-threshold','The Threshold','Fig. XIX','tank'],
           ['the-sacristy','The Sacristy','Fig. XX','sweatshirt'],
           ['the-frieze','The Frieze','Fig. XXI','hoodie'],
           ['assembly-back','The Assembly','Fig. XXII','sleeveless-hoodie']];
  const IX={}; PR.forEach((p,i)=>IX[p.slug]=i);
  const rail=document.getElementById('rail');
  rail.innerHTML = R.map(([f,t,n,sl])=>{
    const i=IX[sl], nm=i===undefined?'':PR[i].name;
    return `<figure data-i="${i}" tabindex="0" role="button" aria-label="${t} — open ${nm}">
      <div class="fw"><img src=${SOGA[f+'.webp']||''} alt="${t}" loading="lazy" decoding="async">
        <div class="cta"><span class="nm">${nm}</span><span class="ar">&rarr;</span></div></div>
      <figcaption><span>${t}</span><span>${n}</span></figcaption></figure>`;}).join('');
  function toPDP(el){ const c=document.querySelector('.pc[data-i="'+el.dataset.i+'"]'); if(c) c.click(); }
  rail.addEventListener('click',e=>{
    const f=e.target.closest('figure[data-i]'); if(!f)return; toPDP(f);
  });
  rail.addEventListener('keydown',e=>{
    if(e.key!=='Enter'&&e.key!==' ')return;
    const f=e.target.closest('figure[data-i]'); if(!f)return; e.preventDefault(); toPDP(f);
  });

  /* the rail must look scrollable — arrows, a counter and a progress hairline */
  const wrap=document.getElementById('railWrap'), bar=document.getElementById('railBar'),
        ct=document.getElementById('railCt'),
        prev=document.getElementById('railPrev'), next=document.getElementById('railNext');
  const step=()=>{ const f=rail.querySelector('figure');
    return f ? f.getBoundingClientRect().width + 18 : rail.clientWidth*0.8; };
  function sync(){
    const max=rail.scrollWidth-rail.clientWidth;
    const frac=max>0?rail.scrollLeft/max:0;
    const vis=Math.max(.08,rail.clientWidth/rail.scrollWidth);
    bar.style.width=(vis*100)+'%';
    bar.style.transform='translateX('+(frac*(100/vis-100))+'%)';
    const n=Math.min(R.length,Math.round(rail.scrollLeft/step())+1);
    ct.textContent=String(n).padStart(2,'0')+' / '+R.length;
    prev.disabled = rail.scrollLeft<=2;
    next.disabled = rail.scrollLeft>=max-2;
    wrap.classList.toggle('end', rail.scrollLeft>=max-2);
  }
  prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>rail.scrollBy({left: step(),behavior:'smooth'}));
  rail.addEventListener('scroll',sync,{passive:true});
  addEventListener('resize',sync);
  sync();
})();


/* ══ SIZE GUIDE — real flat measurements ══
   Centimetres, measured flat, chest is half-circumference. All eight pieces
   are charted. RT0058 / UT0174 / RB0006 / RB0013 come from
   OCULUS-MASTER.html §Size Chart; RW0024, UT0183, UT0088 and UB0042 were pulled from
   the Tapstitch product size guides (UT0088 read off the inches tab and
   converted — every value lands on an exact half-centimetre, so the source
   table was centimetre-native and nothing was rounded into it). UB0042's master
   figures were re-checked against Tapstitch on 17 Aug and match exactly — the
   length row happening to equal RB0013's is coincidence, not a copy-paste.
   Tapstitch labels the Short's waist and hip without a ½, but its own
   how-to-measure is 'straight across ... from edge to edge', i.e. flat, so the
   (½) labels here are correct.
   Every row is mapped by column LABEL, not position — Tapstitch orders the
   columns differently per product. The notes are the return-killers. */
const SIZEGUIDE = {
  'RT0058':{s:['S','M','L','XL'],
    r:[['Length',65,67,69,71],['Shoulder',57,59,61,63],['Chest (½)',61,63,65,67],
       ['Sleeve',25.5,26.5,27.5,28.5]],
    note:'Cut wide and short — 130 cm full chest on a size L, sitting at the waist rather than below the hip. It is +20% wider in the chest and +30% across the shoulder than a standard tee. Size up for length, not width.'},
  'UT0174':{s:['S','M','L','XL','2XL'],
    r:[['Length',64,66,68,70,72],['Shoulder',53,55,57,59,61],['Chest (½)',58,60,62,64,66]],
    note:'Every gram sits on the body panel and hangs from the shoulder and armhole — there is no sleeve to carry the load. It reads denser on the body than the same weight in a hoodie.'},
  'RB0006':{s:['S','M','L','XL','2XL'],
    r:[['Length',66,68,70,72,74],['Shoulder',62,64,66,68,70],['Chest (½)',59,61,63,65,67]],
    note:'The shoulder is wider than the body is deep — 66 cm shoulder against a 63 cm half-chest on a size L. It shows a lot of side body and it will not sit like a normal vest. That is the cut, not a fault.'},
  'RB0013':{s:['S','M','L','XL','2XL'],
    r:[['Length',73,75,77,79,81],['Shoulder',42,44,46,48,50],['Chest (½)',60,62.5,64.5,67.5,69.5]],
    note:'Long and wide on a narrow strap — 129 cm full chest against a 46 cm shoulder on a size L.'},
  'RW0024':{s:['S','M','L','XL','2XL'],
    r:[['Length',70,72,74,76,78],['Shoulder',57,58.5,60,61.5,63],
       ['Chest (½)',67,69,71,73,75],['Sleeve',61,62,63,64,65]],
    note:'The widest block in the collection — 142 cm full chest on a size L against a 74 cm length, a chest-to-length ratio of 0.96. It reads square. Four hundred grams of cotton fleece holds that block open rather than letting it collapse onto the frame.'},
  'UT0183':{s:['S','M','L','XL','2XL'],
    r:[['Length',71,73,75,77,79],['Shoulder',53,54.5,56,57.5,59],
       ['Chest (½)',61,63,65,67,69],['Sleeve',60.5,61.5,62.5,63.5,64.5]],
    note:'The leanest block in the collection &mdash; 130 cm full chest against a 75 cm length, a 0.87 ratio. It reads long rather than square, and the flat collar holds its shape where a crew would soften.'},
  'UT0088':{s:['S','M','L','XL','2XL'],
    r:[['Length',57.5,59.5,61.5,63.5,65.5],['Shoulder',71,72.5,74,75.5,77],
       ['Chest (½)',72,74,76,78,80],['Sleeve',46.5,47.5,48.5,49.5,50.5]],
    note:'The shortest and the squarest piece in the collection &mdash; 152 cm full chest against a 61.5 cm length on a size L, a ratio of 1.24. It is cut to sit at the waist and it will lift off the belt when you raise your arms. The raglan runs the sleeve into the collar, so the 74 cm shoulder is a drape measurement and not a fit constraint. Go by the chest.'},
  'UB0042':{s:['XS','S','M','L','XL'],
    r:[['Length',73,75,77,79,81],['Waist (½)',35,37,39,41,43],['Hip (½)',65,67,69,71,73]],
    note:'Length is measured from the waistband to the hem, not the inseam &mdash; 77 cm on a medium, which falls below the knee rather than above it. It is a long short by design. The waist is elasticated and drawcorded, so the flat figure is the relaxed measurement and not the limit. Size by the hip.'}
};

(function(){
  const sg=document.getElementById('sizeGuide');
  if(!sg) return;
  const body=document.getElementById('sgBody'), title=document.getElementById('sgTitle');
  const scrim=document.getElementById('sgScrim');
  function close(){ sg.classList.remove('open'); sg.setAttribute('aria-hidden','true');
    if(scrim) scrim.classList.remove('open'); }
  document.getElementById('sgClose').addEventListener('click',close);
  if(scrim) scrim.addEventListener('click',close);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'&&sg.classList.contains('open')) close(); });

  /* ══ THE HOUSE DOCUMENTS ══
     Strict by design, and the strictness is honest: there is no
     warehouse behind this brand. Every piece is cut when it is
     ordered, so a return is not stock coming home — it is a
     garment that can never be sold again. The policy enforces a
     ladder, best outcome first: exchange, credit, cash.
     Benchmarked against Fear of God, Cole Buxton, Represent and
     Corteiz. Fourteen days and a paid return is the tier standard;
     discounted product being non-refundable is standard across
     all four. Nothing here is harsher than the category.
     LEGAL: the UK/EU clause is not optional. Do not remove it.
     TEMPORARY, 6 Sep: house@sunofgod.online is King's
     personal inbox, standing in until the mailboxes exist. Shopify
     does not host mailboxes — it sends and forwards only — so the
     swap is to returns@ / hello@ once Workspace is set up.
     The address was misspelled (one l) in both places from 22 Aug
     until today: every mail sent to it bounced. It is now shown as
     "the House" rather than printed, so the next swap is the two
     mailto: hrefs below and nothing visible changes. */
  const DOCS = {
    returns: {
      t: 'Returns',
      h: '<p class="dlead">Nothing here is held in stock. Your piece is cut and finished once you order it, in your size, and then it is yours alone. Nine hundred and ninety-nine of each, and then never again. Choose deliberately &mdash; and if we have got it wrong, tell us and we will make it right.</p>'
       + '<div class="dsec"><h4>01 &nbsp;&middot;&nbsp; Fourteen days</h4><p>You have fourteen days from the day your order arrives to tell us you would like to return something, and fourteen days after that to get it back to us.</p></div>'
       + '<div class="dsec"><h4>02 &nbsp;&middot;&nbsp; Every return is authorised first</h4><p>Write to <b><a href="mailto:house@sunofgod.online?subject=Return%20%E2%80%94%20order%20">the House</a></b> with your order number and we will reply with an authorisation and the address to use. We do not publish a returns address. Anything sent back without an authorisation cannot be refunded and cannot be returned to you.</p></div>'
       + '<div class="dsec"><h4>03 &nbsp;&middot;&nbsp; Exchange &mdash; free</h4><p>Wrong size is the easiest thing in the world to fix. One free exchange per order, same piece, different size. We pay the postage in both directions.</p></div>'
       + '<div class="dsec"><h4>04 &nbsp;&middot;&nbsp; Credit &mdash; free, and worth more</h4><p>Take house credit instead of cash and we will add ten percent. It is issued the moment we approve the return, before the parcel has even reached us, and it is good for twelve months. Credit cannot later be converted to cash.</p></div>'
       + '<div class="dsec"><h4>05 &nbsp;&middot;&nbsp; Under $95, keep it</h4><p>If the piece is under ninety-five dollars we would rather you kept it than posted it back. Tell us what went wrong, keep the garment, take the credit. Once per customer.</p></div>'
       + '<div class="dsec"><h4>06 &nbsp;&middot;&nbsp; Cash refund</h4><p>Available within the same fourteen days, less a return fee:</p>'
       + '<table class="dfee"><tbody>'
       + '<tr><td>United States</td><td>$15</td></tr>'
       + '<tr><td>United Kingdom</td><td>&pound;12</td></tr>'
       + '<tr><td>European Union</td><td>&euro;14</td></tr>'
       + '<tr><td>Australia &middot; Canada</td><td>$20</td></tr>'
       + '<tr><td>Rest of world</td><td>$30</td></tr>'
       + '</tbody></table>'
       + '<p>Original shipping is not refunded. If a return takes your order below the free-shipping threshold, the shipping you did not pay comes out of the refund.</p></div>'
       + '<div class="dsec"><h4>07 &nbsp;&middot;&nbsp; Sets are exchange or credit only</h4><p>The Sets are sold below the price of their parts. Discounted pieces are not returnable for cash &mdash; exchange or house credit only. Return one piece from a Set and the refund is calculated at the Set price, not the individual price.</p></div>'
       + '<div class="dsec"><h4>08 &nbsp;&middot;&nbsp; Condition</h4><p>Unworn, unwashed, tags attached, in the original packaging and free of scent. A piece that comes back short of that may have its refund reduced, or declined.</p></div>'
       + '<div class="dsec"><h4>09 &nbsp;&middot;&nbsp; If something is wrong with it</h4><p>Five days from delivery. Send your order number and photographs. If it is a fault, a misprint or damage in transit we will replace it or refund it in full, and you pay nothing &mdash; no fee, no postage, and none of the limits above apply.</p></div>'
       + '<div class="dsec"><h4>10 &nbsp;&middot;&nbsp; One return per order</h4><p>One exchange, or one return, per order.</p></div>'
       + '<p class="dfoot">If you are in the United Kingdom or the European Union you have fourteen days from delivery to withdraw from your order and receive a refund to your original payment method, including standard outbound shipping. Nothing above removes that right; the return fee still applies. Rights in respect of faulty goods are separate again and are not limited by this policy.</p>'
    }
  };

  DOCS.sizing = { t:'Sizing',
      h: '<p class="dlead">Every piece in Oculus is drawn on the same oversized block. A size L in one is a size L in all of them. If you fall between two sizes the cut is generous enough that we would size down before we sized up.</p>'
       + '<div class="dsec"><h4>01 &nbsp;&middot;&nbsp; Where your size lives</h4><p>Every piece carries its own chart, measured from the finished garment rather than from a body. Open any piece and choose <b>Size guide</b> beside the sizes.</p></div>'
       + '<div class="dsec"><h4>02 &nbsp;&middot;&nbsp; How we measure</h4><p>Centimetres, taken with the garment laid flat. Chest is half the circumference &mdash; double the number in the chart to compare it against a full measurement.</p></div>'
       + '<div class="dsec"><h4>03 &nbsp;&middot;&nbsp; The honest way to do this</h4><p>Do not measure yourself. Take a piece you already own and love the fit of, lay it flat, and measure the chest and the length. Compare those two numbers to the chart. It is faster and it is far more accurate.</p></div>'
       + '<div class="dsec"><h4>04 &nbsp;&middot;&nbsp; The cut</h4><p>Boxy through the body, dropped at the shoulder, shortened at the hem. Heavy cloth throughout &mdash; 270 to 400 gsm. These are not slim garments and they are not meant to be.</p></div>'
       + '<div class="dsec"><h4>05 &nbsp;&middot;&nbsp; Still unsure</h4><p>Write to us before you order. We would far rather answer a question than process a return.</p></div>' };

  DOCS.shipping = { t:'Shipping',
      h: '<p class="dlead">Nothing here is held in stock. Your piece is cut and finished once you order it, and then shipped from the United States.</p>'
       + '<div class="dsec"><h4>01 &nbsp;&middot;&nbsp; Two stages, not one</h4><p>Making comes first, then transit. Your piece is made to order, which takes a few working days before anything ships. The delivery estimate at checkout begins when the parcel leaves, not when you place the order.</p></div>'
       + '<div class="dsec"><h4>02 &nbsp;&middot;&nbsp; Free over $150</h4><p>Standard shipping is free on orders over one hundred and fifty dollars. Below that it is calculated at checkout by destination.</p></div>'
       + '<div class="dsec"><h4>03 &nbsp;&middot;&nbsp; Worldwide</h4><p>We ship worldwide from the United States.</p></div>'
       + '<div class="dsec"><h4>04 &nbsp;&middot;&nbsp; Duties and taxes</h4><p>Orders outside the United States may attract import duty and local tax on arrival. These are set by your country, not by us, and they are the recipient&rsquo;s responsibility. We have no control over them and cannot predict them.</p></div>'
       + '<div class="dsec"><h4>05 &nbsp;&middot;&nbsp; Tracking</h4><p>A tracking number is sent the moment your parcel leaves. If the carrier records a delivery you did not receive, tell us within forty-eight hours.</p></div>'
       + '<div class="dsec"><h4>06 &nbsp;&middot;&nbsp; Wrong address</h4><p>Tell us within twenty-four hours of ordering. Once a piece has gone into production the address is fixed and we cannot change it. A parcel returned to sender is chargeable to send again.</p></div>' };

  DOCS.contact = { t:'Contact',
      h: '<p class="dlead">One inbox, answered by the house. No ticket numbers, no queue.</p>'
       + '<div class="dsec"><h4>Email</h4><p><b><a href="mailto:house@sunofgod.online">Write to the House</a></b></p><p>Within two working days, usually sooner. Email reaches us fastest and it leaves a record for both of us.</p></div>'
       /* +27 = South Africa. The number MUST carry the country code: the
          house ships worldwide and a bare 076 cannot be dialled from the
          US or the UK. SAST is UTC+2 — say the hours so nobody calls at 3am. */
       + '<div class="dsec"><h4>Telephone</h4><p><b><a href="tel:+27763808039">+27 76 380 8039</a></b></p><p>South Africa, GMT+2. Weekdays, nine until five.</p></div>'
       + '<div class="dsec"><h4>Returns and exchanges</h4><p>Read the returns terms first, then write with your order number. Every return is authorised before anything is posted &mdash; we will reply with an authorisation and the address to use.</p></div>'
       + '<div class="dsec"><h4>Sizing</h4><p>Ask before you order. Tell us the piece, your usual size, and the fit you are after, and we will tell you straight.</p></div>'
       + '<div class="dsec"><h4>Press and wholesale</h4><p>Same address. Mark the subject line and it will find its way.</p></div>' };

  window.SOGDOC = function(k){
    const d = DOCS[k]; if(!d) return;
    title.textContent = d.t;
    body.innerHTML = d.h;
    sg.classList.add('doc');
    if(scrim) scrim.classList.add('open');
    sg.classList.add('open'); sg.setAttribute('aria-hidden','false');
    sg.scrollTop=0;
    setTimeout(function(){try{document.getElementById('sgClose').focus()}catch(e){}},420);
  };

  document.addEventListener('click',function(e){
    const a=e.target.closest('[data-doc]'); if(!a) return;
    e.preventDefault(); e.stopPropagation();
    window.SOGDOC(a.getAttribute('data-doc'));
  });

  window.SOGSIZE = function(p){
    sg.classList.remove('doc');
    title.textContent = 'Oculus '+p.name+' — size guide';
    const g=SIZEGUIDE[p.code];
    if(!g){
      body.innerHTML='<p class="none">Flat measurements for this piece have not been captured yet. '
        +'Rather than publish a number we have not measured, we would rather you asked — '
        +'and every piece is cut on the same oversized block as the rest of the collection.</p>';
    } else {
      body.innerHTML='<p class="unit">Centimetres · measured flat · chest is half-circumference, double it for the full measurement</p>'
        +'<table><thead><tr><th>Measure</th>'+g.s.map(z=>'<th>'+z+'</th>').join('')+'</tr></thead><tbody>'
        +g.r.map(row=>'<tr><td>'+row[0]+'</td>'
            +row.slice(1).map(v=>'<td>'+v+'</td>').join('')+'</tr>').join('')
        +'</tbody></table>'
        +(g.note?'<p class="note">'+g.note+'</p>':'');
    }
    if(scrim) scrim.classList.add('open');
    sg.classList.add('open'); sg.setAttribute('aria-hidden','false');
    sg.scrollTop=0;
    setTimeout(function(){try{document.getElementById('sgClose').focus()}catch(e){}},420);
  };
})();


/* ══ 03b · THE SETS ══
   Composition is economic, not decorative. From OCULUS-COST-MECHANICS §E:
   a single tee returns $54 contribution; hoodie + tee returns $176. Freight is
   charged first-item + additional-item, so the second unit ships for ~$1.91
   against $7.09 for the first — that spread, not psychology, is why a set works.

   The discount is 6%. Eightx's contribution analysis finds ~60% of DTC bundles
   are margin-dilutive at launch because founders default to 20–25%; the safe
   ceiling is what the basket genuinely saves operationally, which here is one
   freight first-item plus one payment fee. 6% clears that and no more.

   Set price is stated. The individual total is placed under it, quietly, once.
   No strike-through, no percentage, no "SAVE". This line does not do markdowns. */
(function(){
  const grid=document.getElementById('setGrid');
  if(!grid) return;
  const money=n=>'$'+n.toLocaleString('en-US');
  const priceOf=p=>parseFloat(String(p.px).replace(/[^0-9.]/g,''))||0;

  /* indices into PR — 0 Sleeveless · 1 Sweatshirt · 2 Quarter-Zip · 3 Hoodie
                       4 Boxy Tee · 5 Hooded Tank · 6 Tank · 7 Short          */
  /* Discount escalates with commitment, and stops where contribution stops
     paying for it. 6 / 8 / 10 / 15% — computed against the US Ladder B rate
     card, contribution rises at every rung: $160 -> $227 -> $304 -> $520
     against $54 for a single tee. Wardrobe.NYC discounts 30-40%, but their
     t-shirt is $250; at our prices 30% drops the collection under 60% margin.

     Four sets, not one. The "keep it to a single offer" rule has no support:
     Scheibehenne, Greifeneder & Todd (2010), JCR 37(3) — 63 data points,
     N=5,036 — put choice overload at D=0.02, indistinguishable from zero, and
     found MORE options helped when the outcome measured was quantity bought.

     Sizes are chosen per piece, not per set. Wardrobe.NYC allows exactly this,
     and it removes the single biggest objection to buying a multi-garment box. */
  /* Sets 01 and 02 share no piece. That is deliberate — they are additive, not
     substitutes, so a customer can own both. Every set carrying the hoodie made
     them a choice; this makes them a sequence.

     Discount escalates with commitment and stops where contribution stops paying
     for it: 6 / 7 / 10 / 15%. Contribution rises at every rung — $160 -> $207 ->
     $304 -> $520 — against $54 for a single tee. */
  const SETS=[
    {n:'Essentials', sub:'Two pieces', items:[3,4], price:235, img:'oculus-set-essentials-01.webp',
     line:'Four hundred gram fleece over jersey. The two the collection was drawn around.'},
    {n:'The Kit', sub:'Three pieces', items:[2,5,7], price:345, img:'oculus-set-kit-01.webp',
     line:'Open at the throat, the arm, the knee. Heavy everywhere it touches.'},
    {n:'The Wardrobe', sub:'Four pieces', items:[3,1,4,7], price:465, img:'oculus-set-wardrobe-01.webp',
     line:'Both weights of fleece, the tee beneath, the short below. The full range of the cloth in one order.'},
    /* nopics — the eight-up strip is the Collection section's job, not this
       card's. Repeating all eight here says nothing the ledger below doesn't
       already say, and it shrinks each garment to a thumbnail. */
    {n:'The Collection', sub:'Eight pieces', items:[0,1,2,3,4,5,6,7], price:840, wide:true, nopics:true,
     line:'All eight. Nine hundred and ninety-nine of each, and then never again.'}
  ];

  grid.innerHTML = SETS.map((st,k)=>{
    const ps=st.items.map(i=>PR[i]);
    const full=ps.reduce((a,p)=>a+priceOf(p),0);
    return `<article class="set${st.wide?' wide':''}${st.nopics?' nopix':''}" data-s="${k}">
      ${st.nopics?'':`<div class="pics"${st.wide?'':` style="grid-template-columns:repeat(${st.img?1:ps.length},1fr)"`}>
        ${st.img?`<img src="${st.img}" alt="Oculus ${st.n}" loading="lazy" decoding="async">`:ps.map(p=>`<img src="${pimg(p,p.f[0])}" alt="Oculus ${p.name}" loading="lazy" decoding="async">`).join('')}
      </div>`}
      <div class="body">
        <span class="ix">${String(k+1).padStart(2,'0')} &nbsp;&middot;&nbsp; ${st.sub}</span>
        <h3>${st.n}</h3>
        <p class="line">${st.line}</p>
        <ul class="pcs">
          ${ps.map(p=>`<li><b>Oculus ${p.name}</b><em>${p.gsm} gsm &middot; ${p.px}</em></li>`).join('')}
        </ul>
        <div class="pr">
          <span class="now">${money(st.price)}</span>
          <s class="was">${money(full)}</s>
          <span class="save">Save ${money(full-st.price)}</span>
        </div>
        <button class="shop dk sm go" type="button"><span>Choose sizes</span></button>
        <div class="pick">
          <div class="pickrows">
          ${ps.map((p,j)=>`<div class="row" data-j="${j}">
            <span class="pn">${p.name}</span>
            <div class="sz">${p.sizes.map(z=>`<button type="button" data-z="${z}">${z}</button>`).join('')}</div>
          </div>`).join('')}
          </div>
          <button class="shop dk sm add" type="button" disabled>
            <span>Join the list</span></button>
        </div>
      </div>
    </article>`;
  }).join('');

  grid.querySelectorAll('.set').forEach((card,k)=>{
    const st=SETS[k], ps=st.items.map(i=>PR[i]);
    const chosen=new Array(ps.length).fill(null);
    const addBtn=card.querySelector('.add');

    card.querySelector('.go').addEventListener('click',()=>{
      card.classList.add('picking');
      const f=card.querySelector('.sz button'); if(f) f.focus();
    });

    card.querySelectorAll('.row').forEach(row=>{
      const j=+row.dataset.j;
      row.querySelectorAll('.sz button').forEach(b=>b.addEventListener('click',()=>{
        row.querySelectorAll('.sz button').forEach(x=>x.classList.remove('sel'));
        b.classList.add('sel');
        chosen[j]=b.dataset.z;
        addBtn.disabled = chosen.some(v=>v===null);
      }));
    });

    addBtn.addEventListener('click',()=>{
      if(chosen.some(v=>v===null)) return;
      const full=ps.reduce((a,p)=>a+priceOf(p),0);
      window.SOGHOUSE && window.SOGHOUSE.ask('set',['want:'+String(st.n).toLowerCase().replace(/[^a-z0-9]+/g,'-')].concat(chosen.map(function(z){return 'size:'+z})));
      addBtn.querySelector('span').textContent='On the list';
      setTimeout(()=>{
        card.classList.remove('picking');
        chosen.fill(null);
        card.querySelectorAll('.sz button').forEach(x=>x.classList.remove('sel'));
        addBtn.disabled=true;
        addBtn.querySelector('span').innerHTML='Join the list';
      },420);
    });
  });
})();


/* ══ THE BAG — state, render, open/close ══ */
(function(){
  const BAG=[];                                   // {i, size, qty, sid}
  const CREDITS=[];                               // {sid, name, amount}
  let SEQ=0;
  const panel=document.getElementById('bagPanel'),
        scrim=document.getElementById('bagScr'),
        list =document.getElementById('bagItems'),
        subEl=document.getElementById('bagSub'),
        hdEl =document.getElementById('bagHd'),
        coBtn=document.getElementById('bagCheckout'),
        count=document.querySelector('nav .bag .ct');
  const money=n=>'$'+n.toLocaleString('en-US');
  const priceOf=p=>parseFloat(String(p.px).replace(/[^0-9.]/g,''))||0;

  function render(){
    const units=BAG.reduce((s,l)=>s+l.qty,0);
    const gross=BAG.reduce((s,l)=>s+priceOf(PR[l.i])*l.qty,0);
    const credit=CREDITS.reduce((s,c)=>s+c.amount,0);
    const total=gross-credit;
    if(count) count.textContent=units;
    hdEl.textContent = units ? 'The Bag ('+units+')' : 'The Bag';
    subEl.textContent=money(total);
    coBtn.disabled=!units;
    list.innerHTML = BAG.length ? BAG.map((l,k)=>{
      const p=PR[l.i];
      return `<div class="bagline">
        <img src="${pimg(p,p.f[0])}" alt="${p.name}" loading="lazy" decoding="async">
        <div>
          <div class="nm">Oculus ${p.name}</div>
          <div class="mt">Size ${l.size} &middot; ${p.gsm} gsm</div>
          <div class="qt">
            <button data-k="${k}" data-d="-1" aria-label="Reduce quantity">&minus;</button>
            <span>${l.qty}</span>
            <button data-k="${k}" data-d="1" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="rt">
          <span class="pr">${money(priceOf(p)*l.qty)}</span>
          <button class="rm" data-rm="${k}">Remove</button>
        </div>
      </div>`;}).join('')
        + CREDITS.map(c=>`<div class="bagline credit">
            <div class="nm">${c.name} &mdash; set</div>
            <div class="rt"><span class="pr">&minus;${money(c.amount)}</span></div>
          </div>`).join('')
      : '<div class="empty">Nothing chosen yet.</div>';
  }
  function open(){ panel.classList.add('open'); scrim.classList.add('open');
    panel.setAttribute('aria-hidden','false'); document.body.classList.add('locked'); }
  function close(){ panel.classList.remove('open'); scrim.classList.remove('open');
    panel.setAttribute('aria-hidden','true');
    if(!document.getElementById('pdp').classList.contains('open')) document.body.classList.remove('locked'); }

  window.SOG={
    add(i,size){
      const hit=BAG.find(l=>l.i===i&&l.size===size&&!l.sid);
      if(hit) hit.qty++; else BAG.push({i,size,qty:1});
      render();
    },
    /* a set enters as its own pieces plus one credit line. Break any piece out
       of it and the set dissolves — the rest stay, at their own prices. */
    addSet(name,amount,picks){
      const sid='s'+(SEQ++);
      picks.forEach(p=>BAG.push({i:p.i,size:p.size,qty:1,sid}));
      CREDITS.push({sid,name,amount});
      render();
    },
    open, close
  };

  list.addEventListener('click',e=>{
    const q=e.target.closest('button[data-k]'), r=e.target.closest('button[data-rm]');
    function dissolve(sid){
      if(!sid) return;
      for(let x=CREDITS.length-1;x>=0;x--) if(CREDITS[x].sid===sid) CREDITS.splice(x,1);
    }
    if(q){ const l=BAG[+q.dataset.k]; l.qty+=+q.dataset.d;
           if(l.qty<1){ dissolve(l.sid); BAG.splice(+q.dataset.k,1); } render(); }
    if(r){ dissolve(BAG[+r.dataset.rm].sid); BAG.splice(+r.dataset.rm,1); render(); }
  });
  document.getElementById('bagClose').addEventListener('click',close);
  scrim.addEventListener('click',close);
  addEventListener('keydown',e=>{ if(e.key==='Escape'&&panel.classList.contains('open')) close(); });
  const nb=document.querySelector('nav .bag');
  if(nb) nb.addEventListener('click',e=>{ e.preventDefault(); open(); });
  coBtn.addEventListener('click',()=>{ coBtn.textContent='Checkout opens on release'; });
  render();
})();

/* ══ VEIL — pieces list + image swap on hover ══ */
(function(){
  const ul=document.getElementById('veilPieces');
  ul.innerHTML = PR.map((p,i)=>`<li><a href="#" data-i="${i}"
      data-img="products/${p.slug}/oculus-${p.slug}-${p.f[0]}.webp"
      data-cap="Oculus ${p.name}"><span>${p.name}</span><s>${p.gsm} gsm</s></a></li>`).join('');
  const img=document.getElementById('veilImg'), cap=document.getElementById('veilCap'),
        veil=document.getElementById('veil');
  const DEF={src:'assets/hero.webp',cap:'Ascension — Drop 01'};
  let to;
  function set(src,c){ if(img.getAttribute('src')===src)return;
    img.style.opacity='0'; clearTimeout(to);
    to=setTimeout(()=>{img.src=src; cap.textContent=c; img.style.opacity='1';},220); }
  veil.querySelectorAll('a[data-img]').forEach(a=>{
    a.addEventListener('mouseenter',()=>set(a.dataset.img,a.dataset.cap));
  });
  veil.querySelector('.lft').addEventListener('mouseleave',()=>set(DEF.src,DEF.cap));
  ul.addEventListener('click',e=>{
    const a=e.target.closest('a[data-i]'); if(!a)return; e.preventDefault();
    veil.classList.remove('open'); document.body.classList.remove('locked');
    setTimeout(()=>document.getElementById('grid6')
      .querySelector(`.pc[data-i="${a.dataset.i}"]`).click(), 620);
  });
})();

/* ══ PDP ══ */
(function(){
  const pdp=document.getElementById('pdp'), gal=document.getElementById('pdpGal'),
        side=document.getElementById('pdpSide'),
        stage=document.getElementById('pdpFrames'),
        scnt=document.getElementById('pdpCount'),
        snam=document.getElementById('pdpName'),
        shc=document.getElementById('pdpShc'),
        more=document.getElementById('pdpMore'),
        moreT=document.getElementById('pdpMoreT');
  /* promote the first sentence: it names the garment and the cloth, which is
     what the eye needs before it will commit to the construction detail */
  const lede=d=>{const m=d.match(/^(.*?[.!?])\s+([\s\S]*)$/);
    return m ? '<span class="lead">'+m[1]+'</span>'+m[2] : '<span class="lead">'+d+'</span>';};
  more.addEventListener('click',()=>{
    const sh=document.querySelector('.pdp-sheet');
    if(sh) sh.scrollIntoView({behavior:'smooth',block:'start'});
  });
  const label=fr=>fr.replace(/^\d+-/,'').replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
  const pad=n=>String(n).padStart(2,'0');
  const WORD={1:'One study',2:'Two studies',3:'Three studies',4:'Four studies',
              5:'Five studies',6:'Six studies'};
  const NUM={1:'one',2:'two',3:'three',4:'four',5:'five',6:'six'};
  let sel=null;                       /* current product's selector, set by open() */
  /* one listener, registered once — the sheet is rebuilt per product but this is not */
  gal.addEventListener('click',e=>{
    const im=e.target.closest('img[data-k]'); if(!im||!sel) return;
    sel(+im.dataset.k);
    pdp.scrollTo({top:0,behavior:'smooth'});
  });
  function open(i){
    const p=PR[i];
    const SEAL = `<svg viewBox="0 0 100 410" preserveAspectRatio="xMidYMid meet">
      <defs><linearGradient id="plG" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".30" stop-color="#fff" stop-opacity="1"/>
        <stop offset=".70" stop-color="#fff" stop-opacity="1"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>
      <mask id="plM" maskUnits="userSpaceOnUse" x="-20" y="0" width="140" height="410">
        <rect x="-20" y="0" width="140" height="410" fill="url(#plG)"/></mask></defs>
      <line x1="50" y1="0" x2="50" y2="410" stroke="currentColor" stroke-width="1.75" stroke-opacity=".85"
        vector-effect="non-scaling-stroke" mask="url(#plM)"/>
      <circle cx="50" cy="205" r="46.65" fill="none" stroke="currentColor" stroke-width="4.70"/>
      <circle cx="50" cy="205" r="8.50" fill="currentColor"/></svg>`;
    const plate = `<div class="plate full">
        <span class="rule"></span>
        <span class="cert" style="margin-top:14px">Certificate of Edition</span>
        <span class="seal">${SEAL}</span>
        <span class="mk">SUN OF G&#9737;D</span>
        <span class="drp">Oculus &middot; Drop 01 &middot; MMXXVI</span>
        <span class="aff2">${p.aff}</span>
        <span class="ed2">001 / 999</span>
        <span class="fine">Once made &middot; never remade</span>
      </div>`;
    const N = p.f.length;

    /* the stage — every frame stacked, one lit. First is the PDP's LCP: eager. */
    stage.innerHTML = p.f.map((fr,k)=>
      `<img src="${pimg(p,fr)}" alt="${p.name} &mdash; ${label(fr)}"`
      + (k ? ` loading="lazy"` : ` fetchpriority="high" class="on"`)
      + ` decoding="async">`).join('');
    scnt.textContent = '01 / '+pad(N);
    snam.textContent = label(p.f[0]);
    shc.textContent  = WORD[N] || N+' studies';
    moreT.textContent = 'All '+(NUM[N]||N)+' frames';

    /* the contact sheet below — same frames, clickable back up to the stage */
    gal.innerHTML = p.f.map((fr,k)=>
      `<img src="${pimg(p,fr)}" data-k="${k}" alt="${p.name} &mdash; ${label(fr)}" loading="lazy" decoding="async">`
      ).join('') + plate;

    const strip = `<div class="pdp-strip" style="--n:${N}" role="tablist" aria-label="Product views">`
      + p.f.map((fr,k)=>
        `<button type="button" role="tab" data-k="${k}"`
        + ` aria-selected="${k===0?'true':'false'}" aria-label="View ${k+1} of ${N}: ${label(fr)}"`
        + (k===0?' class="on"':'') + '>'
        + `<span class="fr"><img src="${pimg(p,fr)}" alt="" loading="lazy" decoding="async"></span>`
        + `<i>${pad(k+1)}</i></button>`).join('')
      + `</div>`;

    side.innerHTML = strip + `
      <div>
        <div class="aff">${p.aff}</div>
        <h1>Oculus<br>${p.name}</h1>
        <div class="gar">${p.gar} &middot; ${p.col}</div>
        <div class="ppx">${p.px}</div>
      </div>
      <p class="desc">${lede(p.desc)}</p>
      <div class="spec-hero">
        <span class="big">${p.gsm} <span style="font-size:.5em;letter-spacing:.1em">GSM</span></span>
        <span class="lil">${p.comp}</span>
      </div>
      <dl class="specs">
        <dt>Fit</dt><dd>${p.fit}</dd>
        <dt>Hand</dt><dd>${p.hand}</dd>
        <dt>Shipping</dt><dd>US 3&ndash;5 days &middot; world 7&ndash;14</dd>
        <dt>Made to order</dt><dd>Cut on order, not held in stock</dd>
      </dl>
      <div>
        <div class="szhd"><span class="aff">Size</span>
          <button class="sgo" type="button">Size guide</button></div>
        <div class="sizes">${p.sizes.map(s=>`<button type="button">${s}</button>`).join('')}</div>
      </div>
      <button class="shop dk sm" id="atb" type="button" data-i="${i}"><span>Join the list</span></button>
      <div class="ed">Edition of 999 &middot; once made, never remade</div>`;
    /* ── frame selection ── */
    let cur = 0;
    const stripEl = side.querySelector('.pdp-strip');
    const btns = stripEl.querySelectorAll('button');
    function select(k){
      if(k<0 || k>=N || k===cur) return;
      const ims = stage.children;
      ims[cur].classList.remove('on'); ims[k].classList.add('on');
      btns[cur].classList.remove('on'); btns[cur].setAttribute('aria-selected','false');
      btns[k].classList.add('on');      btns[k].setAttribute('aria-selected','true');
      cur = k;
      scnt.textContent = pad(k+1)+' / '+pad(N);
      snam.textContent = label(p.f[k]);
    }
    sel = select;

    /* ══ MOBILE-ONLY JS ══ max-width:640px guard ══════════════
       On a phone the stage is a horizontal snap rail, not a
       cross-fade deck, so two things have to be wired: a tap on
       the film strip must scroll the rail, and a swipe must drive
       the counter and the strip. Everything below is inside the
       matchMedia guard and cannot execute on a desktop viewport. */
    if (window.matchMedia('(max-width:640px)').matches) {
      const spad = () => parseFloat(getComputedStyle(stage).scrollPaddingLeft) || 0;
      stripEl.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return;
        const im = stage.children[+b.dataset.k];
        if (im) stage.scrollTo({ left: im.offsetLeft - spad(), behavior: 'smooth' });
      });
      let ticking = false;
      stage.addEventListener('scroll', () => {
        if (ticking) return; ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          let best = 0, bd = 1e9;
          Array.prototype.forEach.call(stage.children, (im, k) => {
            const d = Math.abs(im.offsetLeft - spad() - stage.scrollLeft);
            if (d < bd) { bd = d; best = k; }
          });
          select(best);
          if (stage.scrollLeft > 24) stage.parentElement.classList.add('swiped');
        });
      }, { passive: true });

      /* the buy bar becomes the column's own bottom row — moved
         after open() finishes so its click binding is already set */
      requestAnimationFrame(() => {
        const bar = side.querySelector('#atb');
        if (bar) {
          pdp.querySelectorAll(':scope > .shop').forEach(e => e.remove());
          pdp.appendChild(bar);
        }
      });
    }
    /* ══ end mobile-only JS ══════════════════════════════════ */

    /* ══ DESKTOP BUY ROW ═════════════════════════════════════
       Same posture the phone already uses: the CTA is not part of
       the scrolling copy, it is the column's own bottom row. Every
       spec line goes into .pdp-scroll above it, so nothing can ever
       run underneath the button. Rebuilt on each open() because
       innerHTML is reset. */
    if (!window.matchMedia('(max-width:640px)').matches) {
      const bar = side.querySelector('#atb');
      if (bar && !side.querySelector('.pdp-scroll')) {
        const wrap = document.createElement('div');
        wrap.className = 'pdp-scroll';
        while (side.firstChild && side.firstChild !== bar) wrap.appendChild(side.firstChild);
        side.insertBefore(wrap, bar);
        const ed = side.querySelector(':scope > .ed');
        if (ed) wrap.appendChild(ed);
      }
    }
    /* ══ end desktop buy row ═════════════════════════════════ */

    stripEl.addEventListener('click',e=>{
      const b=e.target.closest('button'); if(b) select(+b.dataset.k);
    });
    stripEl.addEventListener('keydown',e=>{
      if(e.key!=='ArrowRight' && e.key!=='ArrowLeft') return;
      e.preventDefault();
      const nx=(cur + (e.key==='ArrowRight'?1:-1) + N) % N;
      select(nx); btns[nx].focus();
    });

    const sgo=side.querySelector('.sgo');
    if(sgo) sgo.addEventListener('click',()=>window.SOGSIZE(p));

    side.querySelectorAll('.sizes button').forEach(b=>b.addEventListener('click',()=>{
      side.querySelectorAll('.sizes button').forEach(x=>x.classList.remove('sel'));
      b.classList.add('sel');
      const a=side.querySelector('#atb');
      a.classList.remove('added');
      a.querySelector('span').innerHTML='Join the list';
    }));
    side.querySelector('#atb').addEventListener('click',()=>{
      const sel=side.querySelector('.sizes button.sel');
      const extra=['want:'+p.slug];
      if(sel) extra.push('size:'+sel.textContent.trim().toLowerCase());
      if(window.SOGHOUSE) window.SOGHOUSE.ask('pdp',extra);
    });
    pdp.classList.add('open'); pdp.setAttribute('aria-hidden','false');
    document.body.classList.add('locked'); pdp.scrollTop=0;
  }
  function close(){pdp.classList.remove('open');pdp.setAttribute('aria-hidden','true');
    document.body.classList.remove('locked')}
  document.getElementById('grid6').addEventListener('click',e=>{
    const a=e.target.closest('.pc'); if(!a)return; e.preventDefault(); open(+a.dataset.i);
  });
  document.getElementById('pdpClose').addEventListener('click',close);
  addEventListener('keydown',e=>{if(e.key==='Escape')close()});
})();

/* 02 · THE STATEMENT — the photograph drifts */
(function(){
  const sec=document.getElementById('statement'), img=document.getElementById('stImg');
  let tk=false;
  addEventListener('scroll',()=>{if(tk)return;tk=true;requestAnimationFrame(()=>{
    const r=sec.getBoundingClientRect();
    if(r.bottom>-200 && r.top<innerHeight+200){
      const p=(innerHeight-r.top)/(innerHeight+r.height);
      img.style.transform=`translateY(${(p-.5)*58}px) scale(1.02)`;
    }
    tk=false});},{passive:true});
})();


/* ── THE VEIL ── */
(function(){
  const v=document.getElementById('veil');
  const open=()=>{v.classList.add('open');document.body.classList.add('locked')};
  const close=()=>{v.classList.remove('open');document.body.classList.remove('locked')};
  document.getElementById('veilOpen').addEventListener('click',open);
  document.getElementById('veilClose').addEventListener('click',close);
  v.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
  addEventListener('keydown',e=>{if(e.key==='Escape')close()});

  /* ══ MOBILE-ONLY JS ══ max-width:640px guard ══════════════
     No hover on a phone: first tap on a piece summons its frame
     into the plate and arms the row; the second tap falls through
     to the close-on-click binding above and opens the piece.
     Capture phase, so the armed row's first tap is intercepted
     before that binding sees it.
     THIS MUST LIVE IN THE VEIL CLOSURE. It sat in the PDP closure
     until 22 Aug, where `v` is not defined — it threw on every
     phone load and the preview never bound. The frozen preview
     drives this with radios, so the fault never showed there. */
  if (window.matchMedia('(max-width:640px)').matches) {
    const vimg = document.getElementById('veilImg');
    const vcap = document.getElementById('veilCap');
    let armed = null;
    v.addEventListener('click', e => {
      const a = e.target.closest('#veilPieces a[data-i]');
      if (!a) { if (armed && !e.target.closest('.close')) { armed.classList.remove('sel'); armed = null; v.classList.remove('pv'); } return; }
      if (armed === a) { armed.classList.remove('sel'); armed = null; v.classList.remove('pv'); return; }
      e.preventDefault(); e.stopPropagation();
      if (armed) armed.classList.remove('sel');
      armed = a; a.classList.add('sel'); v.classList.add('pv');
      if (vimg && a.dataset.img) { vimg.src = a.dataset.img; }
      if (vcap && a.dataset.cap) { vcap.textContent = a.dataset.cap; }
    }, true);
  }
  /* ══ end mobile-only JS ══════════════════════════════════ */
})();

/* reveals */
const io=new IntersectionObserver(e=>e.forEach(x=>x.isIntersecting&&x.target.classList.add('on')),{threshold:.1});
document.querySelectorAll('.rev').forEach((el,i)=>{el.style.transitionDelay=(i%3*.08)+'s';io.observe(el)});

/* hero depth parallax + nav state */
const wmB=document.querySelector('.hero .wm'),wmF=document.querySelector('.hero .wmf'),
      fig=document.querySelector('.hero .fig'),nav=document.getElementById('nav');
let t=false;
addEventListener('scroll',()=>{if(t)return;t=true;requestAnimationFrame(()=>{
  const y=scrollY;
  if(y<innerHeight*1.15){const v=`translateY(${-2.5+y*.045}%)`;wmB.style.transform=v;wmF.style.transform=v;
    fig.style.transform=`translateY(${y*-.09}px)`}
  nav.classList.toggle('solid', y>40);
  t=false});},{passive:true});

(function(){
  const L=window.SOGLIST, f=document.getElementById('wl');
  if(!f) return;
  const said='<span style="font-family:var(--mono);font-size:10px;letter-spacing:.2em;text-transform:uppercase;padding:8px 0">You are on the list</span>';
  if(L.returned()==='foot'){ f.innerHTML=said; L.clean(); }
  f.addEventListener('submit',e=>{
    const i=f.querySelector('input[type=email]'), t=document.getElementById('wlTags');
    if(!i||!L.valid(i.value.trim())){e.preventDefault(); if(i) i.focus(); return}
    if(L.trapped(f)){e.preventDefault();return}
    if(t) t.value=L.tags('footer');
    L.remember(i.value.trim());
  });
})();


/* ══ in-page anchors ─ explicit scroll ══
   Every #anchor on this page changes the hash and then leaves the page
   where it is: the menu links, the hero CTA and the campaign CTA alike,
   in both directions. Two causes, both measured on the live page:
     1. html carries scroll-behavior:smooth. A smooth scroll — from the
        anchor itself or from window.scrollTo — never lands. Setting
        scrollTop with scroll-behavior forced to auto lands and holds.
     2. requestAnimationFrame callbacks never fire here (measured: zero
        frames over two seconds), so the easing runs on setTimeout.
   This does not preventDefault. The native jump is harmless because it
   does nothing, and letting it run keeps the hash update, the hashchange
   and the menu close exactly as they are. We just do the scroll the
   browser failed to do, measured after the menu has closed and layout
   has settled. 56px matches #collection's scroll-margin-top. */
(function(){
  var box = document.scrollingElement || document.documentElement;
  var OFFSET = 56;
  var SKIP = { join: 1 };   /* #join opens the House panel, not a section */

  function still(){
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  function jump(to){
    var prev = box.style.scrollBehavior;
    box.style.scrollBehavior = "auto";
    box.scrollTop = to;
    box.style.scrollBehavior = prev;
  }
  function glide(to, ms){
    var from = box.scrollTop, d = to - from, start = Date.now();
    var prev = box.style.scrollBehavior;
    box.style.scrollBehavior = "auto";
    (function step(){
      var p = Math.min((Date.now() - start) / ms, 1);
      var e = p < .5 ? 4*p*p*p : 1 - Math.pow(-2*p + 2, 3) / 2;
      box.scrollTop = from + d * e;
      if(p < 1) setTimeout(step, 16); else box.style.scrollBehavior = prev;
    })();
  }

  document.addEventListener("click", function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if(!a) return;
    var id = a.getAttribute("href").slice(1);
    if(!id || SKIP[id]) return;
    var target = document.getElementById(id);
    if(!target) return;
    setTimeout(function(){
      var top = target.getBoundingClientRect().top + box.scrollTop - OFFSET;
      if(top < 0) top = 0;
      if(Math.abs(box.scrollTop - top) < 2) return;
      if(still()) jump(top); else glide(top, 640);
    }, 60);
  });
})();
